import { useQuery } from "@apollo/client";
import { Fade, makeStyles } from "@material-ui/core";
import { useFlags } from "@resource/client-ffs";
import TabRouter from "components/legacy/TabRouter";
import FeatureFlags from "generated/FeatureFlags";
import { GetCurrentUserForSettingsPrisma } from "generated/schemaTypes";
import { ReactNode } from "react";
import { ResourceCustomTheme } from "styles/config";
import { useInV2Frame } from "utils/in-iframe";

import CURRENT_USER_FOR_SETTINGS_PRISMA from "./CURRENT_USER_FOR_SETTINGS_PRISMA";

const useStyles = makeStyles((theme: ResourceCustomTheme) => ({
  root: {},
  prompt: {
    marginTop: theme.spacing(2),
  },
  promptText: {
    color: theme.colors.MidnightBlue(300),
  },
  link: {
    textDecoration: "underline",
  },
  subtitleText: {
    marginTop: 7,
    display: "flex",
    alignItems: "center",
    color: "$textGrey",
  },
  routesCont: {
    paddingTop: 20,
  },
}));

function SettingsLayout({ children }: { children?: ReactNode }) {
  const classes = useStyles();
  const { data } = useQuery<GetCurrentUserForSettingsPrisma>(
    CURRENT_USER_FOR_SETTINGS_PRISMA
  );
  const isWithinV2 = useInV2Frame();
  const user = data?.currentUserPrisma;
  const currentOrganization = data?.currentOrganization;
  const prospectOnboardingComplete =
    currentOrganization?.prospectOnboardingComplete;
  const isFreemiumUser = !!user?.currentUserMembership?.hasLimitedAccess;
  const isAtsConfigured = !!currentOrganization?.customer.atsIntegration;
  const { [FeatureFlags.NEW_INTERVIEW_TEMPLATES]: interviewTemplatesEnabled } =
    useFlags();

  const routes = isWithinV2
    ? [
        {
          path: "/settings/company",
          label: "General",
        },
      ]
    : [
        {
          path: "/settings/company",
          label: "General",
        },
        ...(interviewTemplatesEnabled
          ? [
              {
                path: "/settings/interview-templates",
                label: "Interviews",
              },
            ]
          : []),
        {
          path: "/settings/users",
          label: "Users",
        },
        ...(!isFreemiumUser
          ? [
              {
                path: "/settings/integrations",
                label: "Integrations",
              },
            ]
          : []),
        ...(!isFreemiumUser && isAtsConfigured && prospectOnboardingComplete
          ? [
              {
                path: "/settings/configuration",
                label: "Advanced",
              },
            ]
          : []),
      ];

  return (
    <Fade in timeout={500}>
      <div>
        <div className={classes.root}>
          <div>
            <div className="text-display-2 mt-0 mb-8">Settings</div>
            <TabRouter routes={routes} useAtlas>
              {children}
            </TabRouter>
          </div>
        </div>
      </div>
    </Fade>
  );
}

export default SettingsLayout;
